import React from 'react'
import SuccessIcon from 'transfix-icons/build/SuccessIcon'
import { Box } from 'transfix-ui/core'
import { timeSinceShort } from 'utils/formatDatetime'

interface IBCAProps {
  hideBrokerCarrierAgreement: boolean
  brokerCarrierAgreement: {
    createdDate: string
    signedAgreementUrl: string
    signer: {
      id: number
      parentUserId: number
      fullName: string
    }
  }
}
export const BCA: React.FunctionComponent<IBCAProps> = React.memo(
  ({ brokerCarrierAgreement, hideBrokerCarrierAgreement }) => {
    const { createdDate, signedAgreementUrl, signer } = brokerCarrierAgreement || {}
    const { parentUserId } = signer || {}
    return (
      <>
        {hideBrokerCarrierAgreement && (
          <>
            <Box component='span' position='relative' top='4px'>
              <SuccessIcon color='info' size='large' />
            </Box>
            &nbsp;Broker-Carrier Agreement
            <p className='text-secondary'>Signed BCA on file</p>
          </>
        )}
        {!hideBrokerCarrierAgreement && !signer && (
          <>
            <p>Broker-Carrier Agreement</p>
            <p className='text-secondary'>Not Signed</p>
          </>
        )}
        {!hideBrokerCarrierAgreement && signer && (
          <>
            <p>
              <Box component='span' position='relative' top='4px'>
                <SuccessIcon color='info' size='large' />
              </Box>
              &nbsp;Broker-Carrier Agreement
            </p>
            <p className='text-secondary'>
              Signed {timeSinceShort(createdDate)} by&nbsp;
              <a
                href={`${__ROOT__}/users/${parentUserId}`}
                target='_blank'
                rel='noopener noreferrer'
                data-test='bca-user'>
                {signer.fullName}
              </a>
            </p>
            {signedAgreementUrl ? (
              <p>
                <a
                  href={signedAgreementUrl}
                  target='_blank'
                  rel='noopener noreferrer'
                  data-test='bca-agreement'>
                  View Agreement
                </a>
              </p>
            ) : (
              <p className='text-secondary' data-test='no-bca-url'>
                No file found
              </p>
            )}
          </>
        )}
      </>
    )
  }
)
